<template>
    <!--    公共警告框-->
    <el-dialog :title="title" :visible.sync="syncDialog"  width="420px" :modal-append-to-body="false" :close-on-click-modal="false" :show-close="false">
        <!-- 内容 -->
        <el-form v-model="syncForm" ref="syncDataRef">
            <el-form-item label="数据源类型" prop="dataSourceType">
                <el-select v-model="syncForm.dataSourceType" placeholder="请选择" @change="dataSourceTypeChange">
                    <el-option v-for="(item,index) in dataSourceTypeOptinons" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据源名称" prop="metaDataSourceId">
                <el-select v-model="syncForm.metaDataSourceId" placeholder="请选择" @change="metaDataSourceIdChange" value-key="id">
                    <el-option v-for="(item,index) in metaDataSourceIdOptions" :label="item.name" :value="{id:item.id,md5Id:item.md5Id}"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据库名称" prop="dataBaseId">
                <el-select v-model="syncForm.dataBaseId" placeholder="请选择">
                    <el-option v-for="(item,index) in dataBaseIdOptions" :label="item.dataBaseName" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据表" prop="dataTable">
                <el-input v-model="syncForm.dataTable" type="textarea"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer">
            <el-button type="primary" plain @click="cancelConfirm">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        queryBy_dbtype,
        queryBy_md5Id,
        sync_metaData
    } from '@Dcs~/api/metadataList_model'
    export default {
        name: "index",
        props:{
            title:{
                type: String,
                default:'同步元数据'
            },
        },
        data(){
            return{
                syncDialog:false,
                syncForm: {
                    dataSourceType: '',
                    metaDataSourceId: '',
                    dataBaseId: '',
                    dataTable: '',
                },
                dataSourceTypeOptinons:[{ label: 'mysql', value: 'mysql' }, { label: 'hive', value: 'hive' }, { label: 'doris', value: 'doris' }],
                metaDataSourceIdOptions: [],
                dataBaseIdOptions: [],
            }
        },
        methods:{
            init(){
                this.syncDialog = true
            },
            handleConfirm(){
                console.log(this.syncForm)
                sync_metaData(this.syncForm).then(res => {
                    if(res.code == 1){
                        this.syncDialog = false
                        this.syncForm = this.$options.data.call(this).syncForm
                    }
                })
            },
            cancelConfirm(){
                this.syncDialog = false
                this.syncForm = this.$options.data.call(this).syncForm
            },
            //数据源类型变化时
            dataSourceTypeChange(val) {
                this.syncForm = this.$options.data.call(this).syncForm
                this.$refs['syncDataRef'].resetFields()
                this.syncForm.dataSourceType = val
                queryBy_dbtype(val).then((res) => {
                    if (res.code == '1') {
                        this.metaDataSourceIdOptions = res.data
                    }
                })
            },

            //数据源名称变化时
            metaDataSourceIdChange() {
                this.syncForm.dataBaseId = ''
                queryBy_md5Id(this.syncForm.metaDataSourceId.md5Id).then((res) => {
                    if (res.code == '1') {
                        this.dataBaseIdOptions = res.data
                    }
                })
            },


        }
    }
</script>

<style scoped lang="scss">
    .content{
        font-size: 15px;
        i{
            font-size: 20px;
            color: rgb(255,150,62);
        }
    }
</style>
